Foundation.SmoothScroll.defaults.animationDuration = 1000;
Foundation.SmoothScroll.defaults.offset = 100;
jQuery(document).foundation();
